import React from 'react';
import { Image } from 'antd';
import Router from 'next/router';
import { useTranslation } from 'react-i18next';
import { CollectionData } from '../lib/models/NftModel';
import { BNBIcon, ImageLoadFallBack } from '../lib/Resources';
import UserAvatar from './ui/UserAvatar';
import SkeletonLoader from './ui/SkeletonLoader';

export const CollectionCard = ({
  collectionCardData,
}: {
  collectionCardData: CollectionData;
}) => {
  const { t } = useTranslation();

  async function onCollectionClicked() {
    await Router.push(`/drop/${collectionCardData.ID}`);
  }

  return (
    <div
      className="collection-card"
      onClick={onCollectionClicked}
      onKeyDown={onCollectionClicked}
      role="presentation"
    >
      <div className="collection-img-div">
        <Image
          src={
            collectionCardData?.collectionUrlThumbnail ||
            collectionCardData?.collectionUrl
          }
          alt={`Nft ${collectionCardData.collectionTitle}`}
          className="collection-img"
          width="100%"
          fallback={ImageLoadFallBack}
          preview={false}
          placeholder={<SkeletonLoader />}
        />
      </div>

      <div className="collection-card-bottom">
        <div className="row-between">
          <div className="nft-card-name truncate">
            {collectionCardData.collectionTitle}
          </div>
          {collectionCardData.owner && (
            <UserAvatar
              user={collectionCardData.owner}
              isNft
              className="user-avatar-container item-card"
            />
          )}
        </div>
        <div className="collection-bottom-price">
          <div className="collection-img-avatar">
            <img src={BNBIcon} width={20} height={20} alt="Asset logo" />
          </div>
          <div className="collection-card-price">
            <div>
              {t('Total Volume')}:{' '}
              {collectionCardData.collectionTradedVolume
                ? collectionCardData.collectionTradedVolume.toFixed(2)
                : 0.0}{' '}
              BNB
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
